import { useAuth } from '../auth'
import { STATI_INTERVENTO, TIPI_BILANCIA, TIPI_BILANCIA_EM, TIPI_INTERVENTO, CAMPI_STORICO } from '../constants'
import dayjs from 'dayjs'

export function getLabelTipoBilancia(tipo_bilancia: string | undefined) {
  return TIPI_BILANCIA.find((tipo) => tipo.value === tipo_bilancia)?.label
}

export function getLabelTipoBilanciaEm(tipo_bilancia: string | undefined) {
  return TIPI_BILANCIA_EM.find((tipo) => tipo.value === tipo_bilancia)?.label
}

export function getLabelTipoIntervento(tipo_intervento: string | undefined) {
  return TIPI_INTERVENTO.find((tipo) => tipo.value === tipo_intervento)?.label
}

export function getLabelStatoIntervento(stato: string | undefined) {
  return STATI_INTERVENTO.find((s) => s.value === stato)?.label ?? stato
}

export function getLabelCampoStorico(campo: string | undefined) {
  return CAMPI_STORICO.find((c) => c.value === campo)?.label ?? campo
}

export function calcGiorni(data: string) {
  const dataRichiesta = dayjs(data).add(45, 'days')
  const dataOggi = dayjs()
  return dataRichiesta.diff(dataOggi, 'days')
}

const naiveIsObj = (a: any) => typeof a === 'object' && a !== null && !Array.isArray(a)

const arrayze = (a: any) => (Array.isArray(a) ? a : [a])

const naiveIsArrayOfStrs = (a: any) => (Array.isArray(a) ? (a.length > 0 ? typeof a[0] === 'string' : false) : false)

export const transformErrorForForm = (error: any, skipTransform: boolean | string[] = false) => {
  if (error.response?.status === 400) {
    let errorData
    if (naiveIsObj(error?.data)) {
      errorData = error.data as Record<string, any>
    }

    const makeErrors = (errorObj: Record<string, any>): Record<string, any> => {
      return Object.keys(errorObj).reduce((transformed, key) => {
        const rawError = errorObj[key]
        let error
        if (
          skipTransform !== false &&
          (skipTransform === true || (Array.isArray(skipTransform) && skipTransform.includes(key)))
        ) {
          return {
            ...transformed,
            [key]: rawError,
          }
        }
        if (naiveIsObj(rawError)) {
          error = makeErrors(rawError)
        } else if (naiveIsArrayOfStrs(rawError)) {
          error = arrayze(errorObj[key]).join(' ')
        } else if (Array.isArray(rawError)) {
          error = rawError.map((err) => makeErrors(err))
        } else {
          error = arrayze(errorObj[key]).join(' ')
        }
        return {
          ...transformed,
          [key]: error,
        }
      }, {})
    }

    if (errorData) {
      return makeErrors(errorData)
    }
  }
  // When no 400 (not related 2 form)
  // add a special __noFieldsServerError key \w original error
  return {
    __noFieldsServerError: error,
  }
}

// function if we are in production we transform a link download url from http to https
export function transformDownloadUrl(url: string) {
  if (import.meta.env.PROD) {
    return url.replace('http://', 'https://')
  }
  return url
}

export function transformNumberWithCommaAndNumberOfDecimal(number: number | undefined, numberOfDecimal: number) {
  if (!number) {
    return ''
  }
  // return the number with the correct number of decimal and with comma
  return number.toLocaleString('en-US', {
    minimumFractionDigits: numberOfDecimal,
    maximumFractionDigits: numberOfDecimal,
  })
}

export function useIsAmministratore() {
  const { user } = useAuth()
  return user?.role === 'amministratore'
}

export function useIsSupervisore() {
  const { user } = useAuth()
  return user?.role === 'supervisore'
}

export function useIsOperatoreCommerciale() {
  const { user } = useAuth()
  return user?.role === 'operatore_commerciale'
}

export function useIsOperatore() {
  const { user } = useAuth()
  return user?.role === 'operatore'
}

export function useIsCliente() {
  const { user } = useAuth()
  return user?.role === 'cliente' || user?.role === 'responsabile_cliente'
}

export function useIsOnlyCliente() {
  const { user } = useAuth()
  return user?.role === 'cliente'
}

export function useIsResponsabileCliente() {
  const { user } = useAuth()
  return user?.role === 'responsabile_cliente'
}
